import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Input } from "./ui/input";
import { Search, Trophy } from "lucide-react";
import { PortfolioMatrix } from "./PortfolioMatrix";

export const PortfolioOverview = ({ filters }) => {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const params = {};
    if (filters.audit_type !== "all") params.audit_type = filters.audit_type;
    if (filters.region !== "all") params.region = filters.region;
    if (filters.hotel_id !== "all") params.hotel_id = filters.hotel_id;
    api.get("/dashboard/portfolio-matrix", { params }).then((r) => setData(r.data));
  }, [filters.audit_type, filters.region, filters.hotel_id]);

  if (!data) return null;

  const q = search.toLowerCase();
  const rows = data.rows.filter((r) => !q || [r.hotel, r.cluster].some((v) => (v || "").toLowerCase().includes(q)));
  const visible = q ? rows : rows.slice(0, 10);

  return (
    <div className="bg-white border border-[#E7E5DF] rounded-xl p-6" data-testid="portfolio-overview">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
        <div>
          <h3 className="font-semibold text-stone-800 flex items-center gap-2"><Trophy className="w-4 h-4 text-[#14532D]" strokeWidth={1.5} />Portfolio Overview</h3>
          <p className="text-[11px] text-stone-400 mt-0.5">Last score per audit — <span className="text-rose-600 font-semibold">red cells</span> have a missed/overdue audit. Scroll sideways for all audits.</p>
        </div>
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
          <Input data-testid="portfolio-search" className="pl-9 h-9 text-sm" placeholder="Search hotel or cluster..." value={search} onChange={(e) => setSearch(e.target.value)} />
        </div>
      </div>
      <PortfolioMatrix templates={data.templates} rows={visible} testId="portfolio-matrix" />
      {!q && data.rows.length > 10 && (
        <button data-testid="portfolio-show-all" className="mt-3 text-xs font-semibold text-[#14532D] hover:underline" onClick={() => navigate("/progress")}>
          Show all {data.rows.length} hotels →
        </button>
      )}
    </div>
  );
};
